import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/profile.json';
import ar from './i18n/ar/profile.json';

registerFeatureI18n('profile', { en, ar });

export { ProfilePage } from './ProfilePage';
